<template>
  <div class="card-planby">
    <span>Plan by :</span>
    <button type="buuton">
      <div class="card-planby-item">
        <span class="overflow" :class="activeText(data.plan)">
          {{ displayPlanBy(data.plan, data.name) }}
        </span>
      </div>
    </button>
  </div>
</template>

<script>
export default {
  props: ['data'],
  methods: {
    activeText(status) {
      if (status == 0) return ''
      else if (status == '1') return 'text-status s1'
      else if (status == '2') return 'text-status s2'
    },
    displayPlanBy(status, name) {
      var data = null
      if (status == '0') {
        data = null
      } else if (status == '1') {
        data = 'SCG'
      } else if (status == '2') {
        data = name
      } else {
        data = null
      }
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.card-planby {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  // padding-right: 16px;
  &-item {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

button {
  min-width: 125px;
  height: 45px;
  padding: 2px 30px;
  border-radius: 4px;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
}

.text-status {
  font-size: 25px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  &.s1 {
    color: #ea0000;
  }

  &.s2 {
    color: #6b6b6b;
  }
}

.overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
</style>
